import React from 'react'

import Section from '../Section'
import Container from '../Container'

type HintProps = {
  hint: string
  hintUrl?: string
}

const Hint = ({ hint, hintUrl }: HintProps) => {
  return (
    <Section className="hint">
      <Container>
        <div className="hint-content">
          {hint}{' '}
          {hintUrl && (
            <>
              (z.B.{' '}
              <a href={hintUrl} target="_blank">
                Dehner
              </a>
              ).
            </>
          )}
        </div>
      </Container>
    </Section>
  )
}

export default React.memo(Hint)
